const POST_SIGNUP_API_KEY_PROMPT_KEY =
  "api-dashboard:post-signup-api-key-prompt";

/**
 * Queues the API-key prompt for the current browser tab after organization
 * creation. Storage failures must not interrupt signup completion.
 */
export function queuePostSignupApiKeyPrompt() {
  try {
    window.sessionStorage.setItem(POST_SIGNUP_API_KEY_PROMPT_KEY, "true");
  } catch {
    // The prompt is optional; signup remains usable when storage is blocked.
  }
}

/**
 * Reports whether the current tab should show the post-signup API-key prompt.
 *
 * @returns `true` until the queued prompt is dismissed or accepted.
 */
export function hasQueuedPostSignupApiKeyPrompt() {
  try {
    return (
      window.sessionStorage.getItem(POST_SIGNUP_API_KEY_PROMPT_KEY) === "true"
    );
  } catch {
    return false;
  }
}

/** Clears the queued post-signup prompt after either user choice. */
export function clearQueuedPostSignupApiKeyPrompt() {
  try {
    window.sessionStorage.removeItem(POST_SIGNUP_API_KEY_PROMPT_KEY);
  } catch {
    // The marker is best-effort when storage is unavailable.
  }
}
